<template>
  <div class="intro-container">
    <section>
      <article class="article">
        <div class="row">
          <div class="col-lg-6 col-12">
            <p>禾苗（武汉）信息技术有限公司，成立于2015年，专注于为母婴店提供"大数据+新零售"会员精准营销系统。团队有百度、腾讯、阿里巴巴、搜狗、优酷等优势资源支持，拥有百度联盟服务网络。</p>
            <p>
              禾苗仅通过一年时间，就在行业内推出了首个专注于母婴行业"智慧零售"的会员精准营销系统，运用互联网、大数据和人工智能等技术，构建商品、用户、消费等零售要素的数字化，销售、服务等零售运营的智能化，成为国内领先的母婴行业互联网+服务商。
            </p>
            <p>
              公司自成立以来，始终秉承着"让数据将经营变得更高效"的理念，将先进的信息技术、运营策略、管理方法与母婴店实际情况相结合，为母婴店提供会员精准营销系统和全方位的运营服务，帮助母婴店拓展市场、提高管理水平，使母婴店在激烈的市场竞争中始终保持竞争力，实现快速、稳定地发展。
            </p>
            <p>
              截至2018年9月，禾苗已覆盖全国1000家母婴门店，超10000名母婴导购员在熟练使用禾苗导购系统，2000万妈妈正在使用禾苗母婴系统。
            </p>
          </div>
          <div class="img-wrapper col-lg-6 col-12">
            <img src="https://imgcdn.hemiao100.com/weihaojiao/upload/rechargeAdvertise/image/42010016042552/2018-11/e38c6427-b698-49ab-bcd1-717c525ed930.png" alt="公司标志" class="img-fluid">
          </div>
        </div>
      </article>
    </section>
    <div class="row flex-center hm-title">
      <div class="col-3">
        <hr>
      </div>
      <div class="text-center col-6">
        <h3>我们的发展</h3>
      </div>
      <div class="col-3">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img src="@/assets/images/exp.595da4b7.gif" alt="发展历程" class="img-fluid">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutIntro',
  data() {
    return {
      activeTab: 'intro'
    }
  }
}
</script>

<style scoped>
.intro-container {
  padding: 20px;
}

.article {
  margin-bottom: 40px;
}

.article p {
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
}

.img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.img-wrapper img {
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.hm-title {
  margin: 40px 0;
  align-items: center;
}

.hm-title h3 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.hm-title hr {
  border: none;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0;
}

.row {
  margin-bottom: 30px;
}

.row img {
  width: 100%;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .intro-container {
    padding: 15px;
  }
  
  .img-wrapper {
    padding: 10px 0;
  }
  
  .hm-title {
    margin: 30px 0;
  }
  
  .hm-title h3 {
    font-size: 20px;
  }
}
</style>